module.exports = __webpack_public_path__ + "assets/media/drift_500.9d8307b5.svg";